module.exports = __webpack_public_path__ + "img/minty_wallet.ffb97f3c.png";